import {
  Form,
  Tabs,
  Drawer,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MailOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.scss";
import PDFModal from "./component/PDFModal";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import InsuranceVPH from "@/views/AccountPayable/ApprovalSummary/component/InsuranceVPH";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);
  const InsuranceVPHRef = useRef();

  const initTableHead = {
    trust: null,
    prop: null,
    street: null,
    numberOfUnits: null,
    name: null,
    vendid: null,
    glAcct: null,
    amount: null,
    bank:null,
    customerAccount: null,
    invoice: null,
    invoiceDate:null,
    remark:null,
    udate:null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: 'Pay Amount',
      dataIndex: "amount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
      onChange: e => tableFilterFn(e, 'amount'),
    },
    {
      title: 'Prop - Address',
      dataIndex: "propName",
      titleType: 'Input',
      width:180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propName'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => InsuranceVPHRef?.current?.setModalOpen({record})}
            style={{
              color: "#1890ff",
              // textDecoration: "underline dashed",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "GL / Insure",
      dataIndex: "glAcct",
      titleType: "Input",
      width: 160,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Deductible',
      dataIndex: "liabilityDeductible",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityDeductible')
    },
    {
      title: 'Limits',
      dataIndex: "liabilityLimit",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityLimit')
    },
    {
      title: 'Expiration - Effective Date',
      dataIndex: "expirationDate",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => (
        `${record.expirationDate} / ${record.effectiveDate}`
      ),
    },
    {
      title: 'Policy Number',
      dataIndex: "policyNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'policyNumber')
    },
    {
      title: 'Carrier',
      dataIndex: "carrier",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'carrier')
    },
    {
      title: 'Agent',
      dataIndex: "agent",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'agent')
    },
    {
      title: 'Payee',
      dataIndex: "payee",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'payee')
    },
    {
      title: 'Requested By',
      dataIndex: "requestedByName",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => (
        <>
          <div>{record.requestedByName}</div>
          <div>{record.cdateDay}</div>
          <div>{record.cdateTime}</div>
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: "approve",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => (
        <>
          <div>{text}</div>
          <div>{record.udateDay}</div>
          <div>{record.udateTime}</div>
        </>
      ),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const PDFModalRef = useRef();

  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      module: new URLSearchParams(location.search).get("module"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.ASInsuranceDetail, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter
    if(columnKey ==='trust'){
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      }
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      module: new URLSearchParams(location.search).get("module"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportInsuranceCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `Insurance`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      <PDFModal ref={PDFModalRef} record={currentRecord} />

      <InsuranceVPH ref={InsuranceVPHRef} amountUrl={api.ASInsuranceAmount} />

    </div>
  );
});
export default MainTable;